import { api } from './api';

export type NotificationPriority = 'critical' | 'high' | 'normal' | 'low';

export interface ServerNotification {
  id: string;
  chambersId: string;
  userId: string;
  type: string;
  priority: NotificationPriority;
  title: string;
  body: string | null;
  link: string | null;
  entityType: string | null;
  entityId: string | null;
  channels: string[];
  readAt: string | null;
  createdAt: string;
}

export async function fetchMyNotifications(opts?: {
  limit?: number;
  unreadOnly?: boolean;
  offset?: number;
  search?: string;
  category?: string;
  priority?: string;
}): Promise<{ notifications: ServerNotification[]; total: number }> {
  const params: Record<string, string> = {};
  if (opts?.limit) params.limit = String(opts.limit);
  if (opts?.unreadOnly) params.unreadOnly = 'true';
  if (opts?.offset) params.offset = String(opts.offset);
  if (opts?.search) params.search = opts.search;
  if (opts?.category) params.category = opts.category;
  if (opts?.priority) params.priority = opts.priority;
  const res = await api.get<{ notifications: ServerNotification[]; total: number }>('/notifications', {
    params,
    headers: { 'Cache-Control': 'no-store', Pragma: 'no-cache' },
  });
  return res.data;
}

export async function fetchUnreadCount(): Promise<number> {
  const res = await api.get<{ count: number }>('/notifications/unread-count', {
    headers: { 'Cache-Control': 'no-store', Pragma: 'no-cache' },
  });
  return res.data.count;
}

export async function markNotificationRead(id: string): Promise<void> {
  await api.post(`/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<{ updated: number }> {
  const res = await api.post<{ updated: number }>('/notifications/mark-all-read');
  return res.data;
}

export async function dismissNotification(id: string): Promise<void> {
  await api.delete(`/notifications/${id}`);
}
